import axios from 'axios';
import { Dispatch } from 'redux';
import { IUserEmail, UserAction, UserActionTypes } from '../../types/user';
import { errorHandler } from '../../utils/service';
import { setAlert } from './alert';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const getAllUsers = () => async (dispatch: Dispatch<UserAction>) => {
  try {
    dispatch({
      type: UserActionTypes.USERS_LOADING,
    });

    const res = await axios.get('/api/users');
    dispatch({
      type: UserActionTypes.GET_ALL_USERS,
      payload: res.data,
    });
  } catch (error) {
    errorHandler({ error, dispatch, setAlert });
    dispatch({
      type: UserActionTypes.GET_ALL_USERS,
      payload: [],
    });
  }
};

export const addUser =
  (data: any) => async (dispatch: Dispatch<UserAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: UserActionTypes.BTN_LOADING,
        payload: true,
      });

      await axios.post('/api/users', body, config);
      dispatch(getAllUsers());
      dispatch({
        type: UserActionTypes.BTN_LOADING,
        payload: false,
      });
      return true;
    } catch (error: any) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: UserActionTypes.BTN_LOADING,
        payload: false,
      });
    }
    return false;
  };

export const updateUser =
  (data: any) => async (dispatch: Dispatch<UserAction | any>) => {
    const body = JSON.stringify(data.body);
    try {
      dispatch({
        type: UserActionTypes.BTN_LOADING,
        payload: true,
      });

      await axios.put(`/api/users/${data.id}`, body, config);
      dispatch(getAllUsers());
      dispatch({
        type: UserActionTypes.BTN_LOADING,
        payload: false,
      });
      return true;
    } catch (error: any) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: UserActionTypes.BTN_LOADING,
        payload: false,
      });
    }
    return false;
  };

export const deleteUser =
  (id: string) => async (dispatch: Dispatch<UserAction | any>) => {
    try {
      dispatch({
        type: UserActionTypes.BTN_LOADING,
        payload: true,
      });

      await axios.delete(`/api/users/${id}`);
      dispatch(getAllUsers());
      dispatch({
        type: UserActionTypes.BTN_LOADING,
        payload: false,
      });
      return true;
    } catch (error: any) {
      errorHandler({ error, dispatch, setAlert });
    }
    dispatch({
      type: UserActionTypes.BTN_LOADING,
      payload: false,
    });
    return false;
  };

export const sendEmail =
  (data: IUserEmail) => async (dispatch: Dispatch<UserAction | any>) => {
    const body = JSON.stringify(data);
    try {
      const res = await axios.post('/api/email', body, config);

      if (res.data) {
        dispatch(setAlert(res.data, 'success'));
      } else {
        dispatch(setAlert('Email not sent', 'error'));
      }
      return res.data;
    } catch (error: any) {
      errorHandler({ error, dispatch, setAlert });
    }
  };

export const clearUsers = () => async (dispatch: Dispatch<UserAction>) => {
  dispatch({
    type: UserActionTypes.CLEAR_USER,
  });
};
